import React from 'react'
import './AboutContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { FaLaptopCode, FaCoffee } from 'react-icons/fa'

export class AboutContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hideForm: false,
    }
  }

  render() {
    return (
      <div className="about-content">
        {/* Intro */}
        <div className="split light subheader-block">
          <div className="text-wrap">
            We started as a startup consultancy. Now we build AI-enabled decision advantage software for the US Government - mission-critical platforms combining MLOps, DevSecOps, and cybersecurity at scale
          </div>
        </div>

        {/* What Sets Us Apart */}
        <div className="split whitebg content-block">
          <div className="image-wrap">
            <div
              className="image"
              style={{ backgroundImage: 'url("/laptop-code.jpg")' }}
            />
          </div>
          <div className="text-wrap">
            <div className="text-wrap-inner">
              <div className="title">
                Full-Stack Mission Software
              </div>
              <div className="description">
                Trusted by DoD Software Factories like Platform One, we build the cloud-native infrastructure and AI systems powering critical missions. From custom inference models for command and control systems to MLOps pipelines for operational AI, we integrate DevSecOps rigor with cybersecurity-first design. Our teams build production-grade decision advantage software for hard problems in niche, high-consequence domains where bleeding edge meets mission critical.
              </div>
            </div>
          </div>
        </div>

        {/* Who We Serve */}
        <div className="split whitebg content-block border">
          <div className="text-wrap">
            <div className="text-wrap-inner">
              <div className="title">Trusted by Mission-Critical Organizations</div>
              <div className="description">
                We deliver for organizations operating at the highest stakes. Our work spans the Department of Defense (US Air Force, Army, Navy), Department of Homeland Security (USCIS), Health & Human Services (FDA), Department of State, and NOAA. We hold prime and subcontracts building AI-enabled software and DevSecOps platforms where failure isn't an option. These partnerships demand enterprise-scale reliability with startup-speed execution - exactly what we're built for.
              </div>
            </div>
          </div>
          <div className="image-wrap">
            <div
              className="image"
              style={{ backgroundImage: 'url("/clients.png")' }}
            />
          </div>
        </div>

        {/* Our Values */}
        <div className="split light subheader-block">
          <div className="text-wrap">
            We hire lifelong learners who bring relentless energy to hard problems. Our values: mission obsession, engineering excellence, and effective communication. Hard work meets high impact.
          </div>
        </div>

        {/* How We Deliver */}
        <div className="split whitebg content-block">
          <div className="image-wrap">
            <div
              className="image"
              style={{ backgroundImage: 'url("/modernization.png")' }}
            />
          </div>
          <div className="text-wrap">
            <div className="text-wrap-inner">
              <div className="title">
                Services, Solutions, and Products
              </div>
              <div className="description">
                We provide custom engineering services, packaged solutions, and full products depending on what the mission requires. We partner with organizations running mission-critical legacy systems and with VC-backed tech companies building the next generation of tools. This means we can modernize existing platforms while integrating new capabilities - bringing proven stability and frontier innovation together.
              </div>
            </div>
          </div>
        </div>

        {/* Company Origin Story */}
        <div className="split whitebg content-block border">
          <div className="text-wrap">
            <div className="text-wrap-inner">
              <div className="title">From College Dorm to Defense Innovation</div>
              <div className="description">
                Founded in 2015 by Alex Raul, DJ Gagner, and Frank Hackenburg, three University of Maryland grads, Rackner started solving cloud architecture and web development challenges for startups. We scaled quickly to helping Fortune 500 companies tackle complex Kubernetes adoption. Our 2019 US Air Force contract was a turning point - we brought startup agility to government-scale problems and expanded rapidly across federal agencies. Today, we're building mission software at the intersection of AI, DevSecOps, and operational resilience.
              </div>
            </div>
          </div>
          <div className="image-wrap">
            <div
              className="image"
              style={{ backgroundImage: 'url("/about1.jpg")' }}
            />
          </div>
        </div>

        {/* Culture */}
        <div className="split light subheader-block">
          <div className="text-wrap">
            We live on the bleeding edge. Continuous learning is our operating model - free training, certifications, and knowledge sharing fuel growth. We're remote-first with DC Metro headquarters, building high-performance teams. If you're energized by hard problems and meaningful impact, you'll thrive here.
          </div>
        </div>

        <CallToActionBanner
          ahref={'https://boards.greenhouse.io/rackner'}
          icon={FaLaptopCode}
          linkText={'View Job Postings'}
        />
      </div>
    )
  }
}

export default AboutContent
